import React from 'react'
import Navbar from '../Bodysection/Navbar'
import { Outlet } from 'react-router-dom'

const LayoutDesign = () => {
  return (
    <>
        <Navbar />
        <Outlet />   
    </>
  )
}

export default LayoutDesign